import { getGlobalActionProperties } from './globalActionProperties.js';
import { getReporters } from './reporters.js';
import requestIdleCallback from '../utils/requestIdleCallback.js';
import { getUserTraits } from './identify.js';
import LOG from '../logger.js';
/**
 * Used to track a user action in an app
 */
export function track(action, onSend) {
    if (action.ts) {
        LOG.info('Action already has a timestamp. It will be overwritten.');
    }
    // eslint-disable-next-line no-param-reassign
    action.ts = new Date().getTime();
    requestIdleCallback(() => {
        const globalActionProperties = getGlobalActionProperties() || {};
        const userTraits = getUserTraits() || {};
        const reporters = getReporters();
        for (const reporter of Array.from(reporters.values())) {
            reporter.send(action, { globalActionProperties, userTraits }, onSend);
        }
    });
}
//# sourceMappingURL=track.js.map